/** Internal account addresses shared by analytics writers.
 * Surface-specific rules (test fixtures and subdomains) stay with their writers. */
export const INTERNAL_EMAIL_ADDRESSES = new Set([
    'emveras89@gmail.com',
    'hello@bibliokit.com',
    'emilia@componentqa.com',
    'hello@uxbiblio.com',
    'emilia.bibliokit@gmail.com',
    'emiliavedelia@gmail.com',
    'emily.veras@15five.com',
]);
export const INTERNAL_EMAIL_DOMAINS = new Set(['overlayqa.com']);
//# sourceMappingURL=internalEmails.js.map